import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const CLIENT_URL = process.env.REACT_APP_CLIENT_URL || 'http://localhost:3000';

/**
 * Intermediate page on the backoffice origin so "open editor" starts in a
 * normal browser tab (3001), then navigates to the client preview (3000).
 * Avoids the installed Zappy PWA capturing a synthetic link click as a popup window.
 */
const PreviewLauncher = () => {
  const { websiteId } = useParams();

  useEffect(() => {
    if (websiteId) {
      window.location.replace(`${CLIENT_URL}/preview/${websiteId}`);
    }
  }, [websiteId]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <p className="text-gray-600 text-sm">Opening editor…</p>
    </div>
  );
};

export default PreviewLauncher;
